import { parseISO, startOfDay } from "date-fns";
import { TransformGroupCertificationData } from "./types";
import { zonedTimeToUtc } from "date-fns-tz";

export const transformGroupCertificationData = (data: TransformGroupCertificationData) => {
  const { disable_end_date, end_date, ...rest } = data;

  let finalEndDate: string | null = null;

  if (disable_end_date) {
    finalEndDate = "None";
  } else {
    const dateObj = typeof end_date === "string" ? parseISO(end_date) : end_date;

    if (dateObj instanceof Date && !isNaN(dateObj.getTime())) {
      finalEndDate = zonedTimeToUtc(startOfDay(dateObj), "Europe/Paris").toISOString();
    }
  }

  return {
    ...rest,
    end_date: finalEndDate,
  };
};
